module.exports = __webpack_public_path__ + "img/certificateUde.1e589820.png";